import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import "./WorkHighlights.css";
import axios from "axios";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

/* ===== GROUP SLIDES (6 PER SLIDE – SAME LOGIC) ===== */
const groupSlides = (items, perSlide = 6) => {
  let grouped = [];
  for (let i = 0; i < items.length; i += perSlide) {
    grouped.push(items.slice(i, i + perSlide));
  }
  return grouped;
};

const WorkHighlightsCarousel = () => {
  const sliderRef = useRef(null);
  const [mediaItems, setMediaItems] = useState([]);

  const API_URL = "https://admin.cmgroupofcompanies.com"; 

  /* ===== LIGHTBOX STATE ===== */
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  /* ===== FETCH WORK HIGHLIGHTS FROM DB ===== */
  useEffect(() => {
    const fetchWorks = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/projects.php`);
        setMediaItems(res.data);
      } catch (error) {
        console.error("Error fetching work highlights:", error);
      }
    };

    fetchWorks();
  }, []);

  const slides = groupSlides(mediaItems);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="wh-carousel-container-bg">
      <div className="wh-carousel-container">

        {/* HEADER */}
        <div className="wh-carousel-header">
          <h2 className="wh-carousel-title">Work Highlights</h2>

          <div className="wh-carousel-controls">
            <button
              className="wh-nav-btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              ‹
            </button>
            <button
              className="wh-nav-btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              ›
            </button>
          </div>
        </div>

        {/* SLIDER */}
        <Slider ref={sliderRef} {...settings} className="wh-slick">
          {slides.map((group, index) => (
            <div key={index}>
              <div className="wh-grid-wrapper">
                {group.map((item, idx) => (
                  <div className="wh-media-card" key={idx}>
                    <img
                      src={`${API_URL}/uploads/events/${item.image}`}
                      alt="work-highlight"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setPhotoIndex(mediaItems.findIndex(m => m.id === item.id));
                        setIsOpen(true);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Slider>

        {/* LIGHTBOX */}
        {isOpen && (
          <Lightbox
            mainSrc={`${API_URL}/uploads/events/${mediaItems[photoIndex].image}`}
            nextSrc={`${API_URL}/uploads/events/${mediaItems[(photoIndex + 1) % mediaItems.length].image}`}
            prevSrc={`${API_URL}/uploads/events/${mediaItems[(photoIndex + mediaItems.length - 1) % mediaItems.length].image}`}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + mediaItems.length - 1) % mediaItems.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % mediaItems.length)
            }
            imageCaption={`Work Highlight ${photoIndex + 1}`}
          />
        )}

      </div>
    </div>
  );
};

export default WorkHighlightsCarousel;
